import styled from 'styled-components';

export const NavigationWrapper = styled.div`
  background-color: ${props => props.theme.header.background};
  justify-content: flex-end;
  padding: 0 32px;
  display: none;
  position: relative;
  z-index: 1;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: flex;
    height: 40px;
  }
`;
export const NavigationMobileWrapper = styled.div`
  background-color: ${props => props.theme.header.background};
  display: flex;
  height: 37px;
  justify-content: flex-end;
  padding: 0 8px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: none;
  }
`;
